// extracted by mini-css-extract-plugin
export default {"box":"Sstyle_box__PhWpa","Sstyle":"Sstyle_Sstyle__hrzpk"};